'use strict'

export default class help{
    constructor(
        message = "",
        direction = "",
        location = [],
        user = null,
        phone="",
        priority = [{val:"baja",label:"Alimentos",name:'foods',value:true},{val:"alta",label:"Medicamentos",name:'medicines',value:false}],
    ) {
        this.message = message
        this.direction = direction
        this.location = location
        this.user = user
        this.phone = phone
        this.priority = priority
    }

}